import { render, staticRenderFns } from "./MailEventIcon.vue?vue&type=template&id=09b9c0f2"
import script from "./MailEventIcon.vue?vue&type=script&lang=js"
export * from "./MailEventIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports